import { userConstants,CouponConstants, CategoryConstants } from "../_constants";
import * as commonAction from "./commonAction";
import { userService, commonService } from "../_services";
import { alertActions } from "./";
import { history } from "../_helpers";
import { discountConstants } from "../_constants";

//import rootReducer from '../_reducers';
//import { createStore } from 'redux'

//const store = createStore(rootReducer)

export const DiscountActions = {
    saveDiscount,
    getDiscounts,
    editDiscount,
    deleteDiscount,
    getActiveDiscountsOfShop

};

//-- save discount country
function saveDiscount(apiName, catObj) {
  return dispatch => {
    dispatch(commonAction.request(discountConstants.DISCOUNT_ADD_SETTINGS_REQUEST, catObj ));
    commonService.withTokenPut(apiName, catObj).then(
      discountData => {        
                        dispatch(commonAction.success(discountConstants.DISCOUNT_ADD_SETTINGS_SUCCESS, discountData));
                      },
      error => {
                  dispatch( commonAction.failure(discountConstants.DISCOUNT_ADD_SETTINGS_FAILURE, error) );                  
               }
      );
  };
}

// get all discounts settings
function getDiscounts(apiName, catObj) {
    return dispatch => {
      dispatch(commonAction.request(discountConstants.DISCOUNT_GET_SETTINGS_REQUEST, catObj ));
      commonService.withTokenPut(apiName, catObj).then(
        discountData => {        
                          dispatch(commonAction.success(discountConstants.DISCOUNT_GET_SETTINGS_SUCCESS, discountData));
                        },
        error => {
                    dispatch( commonAction.failure(discountConstants.DISCOUNT_GET_SETTINGS_FAILURE, error) );                  
                 }
        );
    };
  }

  function getActiveDiscountsOfShop(apiName, catObj) {
    return dispatch => {
      dispatch(commonAction.request(discountConstants.GET_ACTIVE_DISCOUNT_REQUEST, catObj ));
      commonService.withTokenPut(apiName, catObj).then(
        discountData => {        
                          dispatch(commonAction.success(discountConstants.GET_ACTIVE_DISCOUNT_SUCCESS, discountData));
                        },
        error => {
                    dispatch( commonAction.failure(discountConstants.GET_ACTIVE_DISCOUNT_FAILURE, error) );                  
                 }
        );
    };
  }


  
//-- edit tax country
function editDiscount(apiName, catObj) {
  return dispatch => {
    dispatch(commonAction.request(discountConstants.DISCOUNT_EDIT_SETTINGS_REQUEST, catObj ));
    commonService.withTokenPut(apiName, catObj).then(
      discountData => {        
                        dispatch(commonAction.success(discountConstants.DISCOUNT_EDIT_SETTINGS_SUCCESS, discountData));
                      },
      error => {
                  dispatch( commonAction.failure(discountConstants.DISCOUNT_EDIT_SETTINGS_FAILURE, error) );                  
               }
      );
  };
}

// delete a discount record by id and admin
function deleteDiscount(apiName, catObj) {
  return dispatch => {
    dispatch(commonAction.request(discountConstants.DISCOUNT_DELETE_SETTINGS_REQUEST, catObj ));
    commonService.withTokenPut(apiName, catObj).then(
      discountData => {        
                        dispatch(commonAction.success(discountConstants.DISCOUNT_DELETE_SETTINGS_SUCCESS, discountData));
                      },
      error => {
                  dispatch( commonAction.failure(discountConstants.DISCOUNT_DELETE_SETTINGS_FAILURE, error) );                  
               }
      );
  };
}

 
 
 